const HotelDevices = lazy(() => import('../pages/HotelDevices'))
const CardKeyPage = lazy(() => import('../pages/CardKey'))
const SearchPage = lazy(() => import('../pages/Search'))

import { NonIndexRouteObject, Outlet, createBrowserRouter } from 'react-router-dom'
import { ReactNode, Suspense, lazy } from 'react'

import { HotelLayout } from '../layouts/HotelLayout'
import { ReservationLogin } from '../pages/ReservationLogin'
import { ReservationRouteGuard } from './ReservationRouteGuard'
import { DefaultLayout } from '../layouts/DefaultLayout'
import { Home } from '../pages/Home'
import { CheckInPage } from '../pages/CheckIn'
import { ReviewPage } from '../pages/Review'
import { ReservationPage } from '../pages/Reservation'
import { VietQRPayment } from '../pages/VietQRPayment'
import { IdentityCardGuide } from '../modules/IdentityCardGuide'
import { IdentityCardScanner } from '../modules/IdentityCardScanner'
import CheckInSuccessPage from '../pages/CheckInSuccess'
import CardKeySucessPage from '../pages/CardKeySuccess'

export interface IRouteConfig {
  element: ReactNode
  path: string
  permissions?: string[]
}

const publicRoutes: NonIndexRouteObject[] = [
  {
    element: <ReservationLogin />,
    path: '',
  },
  {
    element: <ReservationLogin />,
    path: 'login',
  },
  {
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <HotelDevices />
      </Suspense>
    ),
    path: 'devices',
  },
  {
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <SearchPage />
      </Suspense>
    ),
    path: 'search',
  },
  {
    element: <ReviewPage />,
    path: 'room/:roomId',
  },
  {
    element: <ReservationPage />,
    path: 'reservation/:reservationId',
  },
]

const authenticatedRoutes = [
  {
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <CardKeyPage />
      </Suspense>
    ),

    path: 'cardkey',
  },
  {
    element: <CardKeySucessPage />,
    path: 'cardkey/success',
  },
  {
    element: <CheckInSuccessPage />,
    path: 'checkin/success',
  },
  {
    element: <CheckInPage />,
    path: 'checkin',
  },
  {
    element: <IdentityCardGuide />,
    path: 'identity-terms',
  },
  {
    element: <IdentityCardScanner />,
    path: 'identity',
  },
  {
    element: <VietQRPayment />,
    path: 'payment',
  },
]

export const defaultRouter = createBrowserRouter([
  {
    element: (
      <DefaultLayout>
        <Outlet />
      </DefaultLayout>
    ),
    children: [
      {
        element: (
          <HotelLayout>
            <Outlet />
          </HotelLayout>
        ),
        children: [
          ...publicRoutes,
          ...authenticatedRoutes.map((item) => ({
            ...item,
            element: <ReservationRouteGuard>{item.element}</ReservationRouteGuard>,
          })),
        ],
        path: '/hotel/:hotelId',
      },
      {
        path: '/',
        element: <Home />,
      },
    ],
  },
])
